var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home-container" },
    [
      _c("vue-progress-bar"),
      _vm._v(" "),
      _c("nav", { staticClass: "home-nav" }, [
        _c("div", { staticClass: "home-nav-content" }, [
          _c(
            "div",
            { staticClass: "logo-name" },
            [
              _c("router-link", { attrs: { to: { path: "/" } } }, [
                _c("img", { attrs: { src: require("../assets/logo.svg") } }),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "user" }, [_c("user-options")], 1),
        ]),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [_c("router-view")], 1),
      _vm._v(" "),
      !_vm.hasNewLeftNavEnabled ? _c("main-footer") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }